export const PIPE_TYPE_TITLE = 'claim.declaration.external_damages.form.visible_pipe.type.title';
export const PIPE_TYPE_PLACEHOLDER = 'claim.declaration.external_damages.form.visible_pipe.type.placeholder';
export const PIPE_LENGTH_TITLE = 'claim.declaration.external_damages.form.visible_pipe.length.title';
